export default {
  locale: "zh-CN",
  language: "简体中文",
  menu: {
    i18n: "多语言"
  },
  page: {
    content: {
      MoreAndMore: "更多",
      loginTip: "您尚未登录 请先登录",
      blockNoData: "暂无更多公告",
      supplierPortal: "首页",
      projectCode: "项目编号",
      publishTime: "发布时间",
      labelMenu1: "评标结果",
      labelMenu2: "流标公告",
      labelMenu3: "补遗公告",
      labelMenu4: "邀请公告",
      labelMenu5: "中标通知",
      labelMenu6: "招标采购",
      labelMenu7: "询价采购",
      labelMenu8: "谈判",
      projectNamePlaceholder: "请输入项目名称",
      search: "搜索",
      allClassify: "全部分类",
      menu1: "首页",
      menu2: "集中采购",
      menu3: "区域联采",
      menu4: "分包商注册",
      menu5: "供应链金融",
      Hello: "您好",
      Exit: "退出",
      supplierLogin: "Hi,欢迎回来",
      pleaseLogin: "登录交建云商",
      Announcements: "通知公告",
      Announcements1: "温馨提示",
      subpackage: "分包",
      purchase: "采购",
      projectName: "项目名称",
      searchPlaceholder: "搜索 项目编号/项目公告",
      packageNum: "包件数量",
      fromEndTime: "距离结束",
      viewDetail: "查看详情",
      downLoad: "下载",
      to: "至",
      startTime: "开始时间",
      endTime: "结束时间",
      joinStatus: "参与状态",
      title: "标题",
      titlePlaceholder: "请输入标题模糊查询",
      serialNo: "序号",
      publishUnit: "发布单位",
      signUpEndTime: "报名结束剩余时间",
      day: "天",
      hour: "时",
      minute: "分",
      second: "秒",
      immediatelySignUp: "立即报名（仅分包商可报名）",
      notice: "公告",
      noticeTitle: "公告标题",
      noticeContent: "公告内容",
      contractInfo: "联系信息",
      fileList: "附件列表",
      supplierBiddingProcess: "分包商投标操作流程",
      pleaseClickView: "请点击查看",
      packageDesc: "包件说明",
      materialInfo: "采购清单",
      quantitiesInfo: "工程量清单",
      relatedNoticeList: "相关公告列表",
      purchaseMoney: "采购金额",
      thousandYuan: "万元",
      camulativePurchaseItems: "累计招标项目",
      inquiryProjectNum: "询价项目数量",
      biddingProjectNum: "竞谈项目数量",
      unitStillPurchase: "该单位还在采购",
      fileName: "附件名称",
      fileSize: "附件大小",
      fileDesc: "附件说明",
      operation: "操作",
      code: "编码",
      name: "名称",
      num: "采购数量",
      quantities: "工程量",
      viewNoticeDetail: "见公告详情",
      unit: "单位",
      featRemark: "项目特征描述",
      remark: "备注",
      type: "类型",
      link: "环节",
      other: "其他",
      aboutUs: "关于我们",
      introPlatform: "平台简介",
      contactUs: "联系我们",
      relevantPoliciesAndRegulations: "相关政策与规范",
      purchaser: "采购方",
      operationGuide: "操作指引",
      videoTutorial: "视频教程",
      supplier: "分包商",
      supplierName: "分包商名称",
      netInformation: "入网须知",
      commonProblem: "常见问题",
      purchaseCommonProblem: "采购方常见问题",
      supplierCommonProblem: "分包商常见问题",
      serviceCenter: "服务中心",
      onlineCounsel: "在线咨询",
      afterSalesService: "售后服务",
      feedback: "意见反馈",
      fileTemplateDownload: "文件模板下载",
      supplyChainFinanceCenter: "供应链金融中心",
      officialWeChat: "官方微信",
      navigation: "栏目导航",
      source: "来源",
      add: "新增",
      author: "作者",
      publishDate: "发布日期",
      all: "全部",
      prev: "< 上一页",
      next: "下一页 >",
      sure: "确定",
      noRelatedData: "暂无相关数据",
      supplierOperationManual: "分包商操作手册",
      operationManual: "操作手册",
      supplierOperationGuide: "分包商操作指南",
      noData: "暂无数据",
      question: "业务流程及常见问题",
      purchaseType: "采购方式",
      materialClassify: "物资分类",
      projectCategory: "工程类别",
      multiSelect: "多选",
      cancel: "取消",
      onlySupplierLogin: "仅分包商登录可选",
      publicBidding: "公开招标",
      publicBiddingXb: "公开询比",
      invitationTenderXb: "邀请询比",
      inquiry: "询价采购",
      competitiveNegotiation: "谈判",
      invitationTender: "邀请招标",
      singleSource: "单一来源",
      nearly3Days: "近3天",
      nearly7Days: "近一周",
      nearly30Days: "近一个月",
      toMyProject: "进入项目"
    },
    sup: {
      title: "分包商操作指南",
      content1: "中国交建电子采购平台 —— 分包商门户（",
      content2:
        "）是分包商加入中国交通建设股份有限公司（以下简称“中国交建”）分包商网络的唯一合法的电子商务网站。中国交建按照“互利共赢、诚信合作”的原则，与分包商建立积极的合作关系。",
      content3:
        "中国交建对分包商实行准入管理，经准入的分包商具备参与中国交建及所属企业的线上投标和报价资格。凡有意参与中国交建采购业务的分包商均须认真阅读入网须知及注册指南，选择",
      content4: "注册（推荐单位为分包商信息的初审单位），经审核通过后入网。",
      content5: "请为保证系统的稳定兼容性，请使用",
      content6:
        "或以上版本的IE浏览器（同时选择兼容模式），以获得最佳效果。设置方法参见：",
      contentStrong: "推荐单位",
      questions: "常见问题解答",
      explain: "其他说明如下：",
      explain1: "1. 分包商入网须知",
      explain2: "2. 注册流程",
      explain3: "3. 常见问题解答",
      explain4: "4. 操作手册",
      explain5: "5. 如何找回密码",
      explain6: "6. 分包商在线投标重要提示及操作流程",
      supNetInformation: "分包商入网须知",
      netInformation1:
        "1.中国交通建设股份有限公司设备物资采购管理信息平台是分包商加入中国交通建设股份有限公司（以下简称“中国交建”）分包商网络的唯一合法网站。中国交建按照“互利共赢、诚信合作”的原则，与分包商建立积极的合作关系。",
      netInformation2:
        "2.中国交通建设股份有限公司对申请入网的分包商不收取任何费用，不颁发相关证书，也不以年审、会员制、业绩考核等名义向分包商收取费用。分包商填写入网信息必须真实、准确并及时更新。",
      netInformation3:
        "3. 如遇系统升级，平台运营方有权延长招标结束时间、售标结束时间。",
      faqName: "分包商在线投标重要提示及操作流程",
      createUserName: "中国交通建设股份有限公司",
      releaseMechanism: "发布机构：",
      releaseTime: "发布时间：",
      titleContent: "为保障招标活动的顺利进行，请投标分包商认真阅读以下内容：",
      titleContent1:
        "一、避开投标高峰时间：高峰时间（8:00—18:00），特别是投标截止日前一天。",
      titleContent2:
        "二、控制投标文件大小：投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件和图片尺寸。",
      titleContent3:
        "三、投标操作：建议分包商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。",
      titleContent4: "四、具体演示：",
      operationProcess: "分包商投标操作流程",
      clickOnTitleToView: "点击标题查看",
      table: {
        title: "附件列表",
        serialNumber: "序号",
        fileName: "附件名称",
        fileSize: "附件大小",
        fileDesc: "附件说明",
        operation: "操作",
        upload: "下载"
      },
      dialog: {
        title: "关于分包商在线投标的重要提示",
        dialogTitle: "为保障招标活动的顺利进行，请投标分包商认真阅读以下内容：",
        content1: "一、避开投标高峰时间",
        contentP1: "高峰时间（每日6:00—18:00），特别是投标截止日前一天。",
        content2: "二、控制投标文件大小",
        contentP2:
          "投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件。",
        content3: "三、投标操作",
        contentP3:
          "建议分包商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。投标操作具体演示如下：",
        participateInBidd: "1.参与招标",
        participateInBiddCont1:
          "1)使用IE浏览器登陆分包商门户网站（http://uat01-sp.iccec.cn）",
        participateInBiddCont2:
          "2)登陆后点击邀请公告。点击一条公告进入后，网页下方有一个参与按钮，点击进入填写联系信息并提交。此时系统会提示您已“报名成功”。",
        biddingDocuments: "2.下载招标文件",
        biddingDocumentsCont1:
          "1)招标人收到标书费用，会通过系统给分包商发送招标文件，您在待办提醒里可以看到采购文件下载",
        biddingDocumentsCont2:
          "2)待办提醒还可以提供答疑、投标、补遗、澄清等信息。",
        tender: "3.投标",
        tenderCont1: "1)投标阶段开始后请查看待办提醒，点击。",
        tenderCont2:
          "2)分包商也可以点击分包商门户地址栏下方的业务协同，进入您的工作界面。",
        tenderCont3:
          "3)进入工作界面后，页面左侧有您参与的方案，点击方案后进入投标菜单进行投标。",
        tenderCont4:
          "4）为避免附件大造成投标失败，建议在投标结束前一天完成网上投标。",
        tenderCont5:
          "您也可以分步上传标书文件，首先填写报价表，并上传技术投标文件，点击提交按钮；此时系统提示",
        aTender: "投标成功",
        tenderCont6: "在商务报价表做好后，在投标菜单点击",
        tenderCont7:
          "按钮，修改报价，通过“上传”按钮把商务报价文件上传至系统后，点击提交完成最终报价。",
        tenderCont8: "备注：请不要点击撤销投标，点击后系统会删除所有投标文件。",
        reportAgain: "再次上报",
        toClarify: "4.澄清",
        toClarifyCont:
          "在评标阶段，招标方会通过系统发布澄清文件，请在待办提醒中查看并回复。",
        question: " 5.质疑",
        questionCont:
          "分包商如对招标文件有疑问，可通过点击首页的业务协同，在业务协同页面左侧找到参与的项目，点击参与的项目找到质疑答疑菜单，上传您的质疑文件，也可查看招标方答疑文件。",
        addendumFile: "6.查看补遗文件",
        addendumFileCont:
          "如果招标方发布补遗文件，您可以在首页的待办提醒里查看。",
        notes: "四、电子标书大小注意事项",
        notesCont1:
          "在制作投标文件的过程中，因投标书含有许多图片导致文件很大而影响上传。为避免提交标书时上传速度慢，请尽量压缩投标文件和图片尺寸，文件大小应控制在30M以内。也可以将Word文件转换为PDF格式并使用压缩包软件，压缩文件大小。",
        notesCont2: "1.转换为PDF格式有2种方法：",
        notesCont3:
          "1) 一种是在Word中直接另存为PDF格式，并压缩尺寸（含Office2007, 2010和2013版本）。",
        notesCont4:
          "2) 一种是安装PDF虚拟打印机，自动生成PDF文档。（Office2003不带PDF转换，就需要安装此软件，PDFCreator软件为开源软件，任何人都可以免费安装使用）。下载地址",
        click: "点击",
        notesCont5: "2.以下为Office 2007及以上版本直接另存为PDF格式的方法：",
        notesCont6:
          "1) 以Office2010为例，在Word文档中选择文件另存为，保存类型选择",
        notesCont7: "2) 在优化项选择“针对以下格式优化",
        notesCont8: "可将文件压缩至20M以内。",
        smallestFileSize: "最小文件大小",
        sure: "确定",
        cancel: "取消",
        spread: "展开",
        shrinkage: "收缩"
      }
    },
    login: {
      title: "分包商登录",
      pwLogin: "密码登录",
      smsLogin: "短信登录",
      pleaseUn: "用户名/手机号",
      pleasePw: "请输入密码",
      loginName: "登录",
      smsSendSuccessTip1: "短信验证码已发送至",
      smsSendSuccessTip2: "请注意查收",
      telNo: "手机号",
      smsVerCode: "短信验证码",
      sendVerCode: "发送验证码",
      sended: "已发送",
      jjt: "交建通",
      wx: "微信",
      Copyright: "Copyright © 2018 中国交建 All rights reserved.",
      statement: "最终解释权：闽ICP备2022005227号-2 中国交建",
      acApiErrorObj: {
        error1: "该登录账号因无效登录超过6次已被锁定30分钟",
        error2: "未实名",
        error3: "登录账号已被冻结",
        error4: "系统服务暂不可用，请稍后重试"
      },
      pwApiErrorObj: {
        error1: "登录账号与登录密码不匹配，请重新输入",
        error2: "请滑动完成验证"
      },
      telErrorObj: {
        error1: "请输入正确的手机号",
        error2: "手机号与短信密码不匹配，请重新输入。",
        error3: "手机号短信验证码无效登录6次，将锁定手机号30分钟",
        error4: "系统服务暂不可用,请稍后重试"
      },
      smsSliderErrorObj: {
        error1: "请滑动完成验证"
      },
      smsErrorObj: {
        error1: "请勿重复发送，倒计时完成后可再次获取验证码",
        error2: "发送验证码失败,请稍后再试"
      },
      upLang: {
        _startTEXT: "请按住滑块，拖动到最右侧",
        _yesTEXT: "验证通过",
        _noTEXT: "验证不通过",
        _error300:
          '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork:
          '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
      }
    }
  }
};
